<template>
  <v-expansion-panel>
    <v-expansion-panel-header class="pl-2">
      <v-icon class="flex-grow-0 pr-4">
        alt_route
      </v-icon>
      <span>Personal Overview</span>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-row
        v-for="(item, index) of summaryItems"
        :key="index"
        class="text-caption"
      >
        <v-col>{{ item.text }}</v-col>
        <v-col>{{ item.value }}</v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { PARTY_NAMESPACE } from '@/store/party'
import { humanize } from '@/utilities/string-utilities'
import { mapGetters } from 'vuex'

export default {
  name: 'PersonalOverviewSummary',

  data () {
    return {
      items: [
        { prop: 'experienced_labor_violation_us', value: null },
        { prop: 'fear_returning_home_country', value: null },
        { prop: 'forced_sexual_encounters', value: null },
        { prop: 'forced_to_work_against_will', value: null },
        { prop: 'hrifa_eligibility', value: null },
        { prop: 'mistreated_by_coyote_in_transit', value: null },
        { prop: 'nacara_eligibility', value: null },
        { prop: 'national_of_tps_designated_country', value: null },
        { prop: 'suffered_mental_harm', value: null },
        { prop: 'suffered_physical_harm_home_country', value: null },
        { prop: 'us_military_service', value: null },
        { prop: 'victim_of_dv_abuse_by_relative_childhood', value: null },
        { prop: 'victim_of_dv_us_usc_relative', value: null },
        { prop: 'victim_of_ucrime_us', value: null },
        { prop: 'notes', value: null },
      ],

      summaryItems: [],
    }
  },

  computed: {
    ...mapGetters(PARTY_NAMESPACE, [
      'peParty',
    ]),
  },

  watch: {
    peParty: {
      handler (val) {
        if (val) this.updateSummaryItems()
      },
    },
  },

  methods: {
    getCorrectText (value) {
      if (value === null) return 'Not answered'
      if (value === -1) return 'Unknown'
      if (value === 0) return 'No'
      if (value === 1) return 'Yes'

      return value
    },

    updateSummaryItems () {
      this.summaryItems = this.items.map(item => ({ ...item, text: humanize(item.prop), value: this.getCorrectText(this.peParty.overview[item.prop]) }))
    },
  },
}
</script>
